import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  useEditStore,
  useToggleEditMode,
} from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';

import { trackIsEditingToggle } from '../../utils/tracking';

import * as Styled from './toggle-edit-mode.styles';

export const ToggleEditMode: FC = () => {
  const isEditing = useEditStore(({ isEditing }) => isEditing);
  const { toggleEditMode } = useToggleEditMode();

  const handleToggleEditMode = (): void => {
    toggleEditMode(!isEditing);
    trackIsEditingToggle(!isEditing);
  };

  return (
    <Styled.Button
      variant={isEditing ? 'secondary' : 'primary'}
      size="small"
      onClick={handleToggleEditMode}
      data-testid={
        isEditing
          ? 'EP_EDIT_ACTION_SET_EDIT_MODE_OFF'
          : 'EP_EDIT_ACTION_SET_EDIT_MODE_ON'
      }
    >
      <FormattedMessage
        id={
          isEditing
            ? 'EP_EDIT_ACTION_SET_EDIT_MODE_OFF'
            : 'EP_EDIT_ACTION_SET_EDIT_MODE_ON'
        }
      />
    </Styled.Button>
  );
};
